import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Form } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useAuth, useApiPost, useApiPatch, useFetch, useBasepathUrl } from "../../../hooks";
import { SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import { apiUrl } from "../../../lib/appConfig";

import BunkForm from "./BunkForm";
import InchargeForm from "./InchargeForm";
import CameraForm from "./CameraForm";

const PetrolBunkForm = ({ mode = 'add', onSubmit, updateFromApiResp, initialBunkData = {}, toploading=false }) => {
  
  const navigate = useNavigate();
  let pageval = (mode === 'edit') ? 2 : 1;
  const basePage = useBasepathUrl(pageval);
  const { recordId } = useParams();

  const [activeForm, setActiveForm] = useState('bunk');
  const [bunkSavedData, setBunkSavedData] = useState(null);
  const [bunkSavedFormData, setBunkSavedFormData] = useState(null);
  const [userSavedData, setUserSavedData] = useState(null);
  const [userSavedFormData, setUserSavedFormData] = useState(null);
  const [fetchUserUrl, setFetchUser] = useState(null);
  const [customerror, setCustomerror] = useState('');
  const { authToken } = useAuth();
  const { postData: postBunkData, loading: bunkloading, error: bunkerror, responseData: bunkResponse } = useApiPost('entities',authToken);
  const { patchData: patchBunkData, loading: updatebunkLoading } = useApiPatch(`entities`, authToken);
  const { postData: postUserData, loading: userloading, error: usererror, responseData: userResponse } = useApiPost('users',authToken);
  const { patchData: patchUserData, loading: updateuserLoading } = useApiPatch(`users`, authToken);

  const { postData: fetchBunk, loading: fetchbunkLoading } = useApiPost(`entities/get-by-id`, authToken);
  const { data: userResData, loading: edituserLoading, error: eduserError } = useFetch(fetchUserUrl, authToken);

  useEffect(() => {
        const fetchBunkData = async () => {
            const payload = JSON.stringify({id:recordId});
            const { result, error } = await fetchBunk(payload);
            if (result?.data) {
            let resData = result?.data;
            let userDetails = {
                bunkName: resData.name,
                bunkAddress1: resData.address1,
                bunkAddress2: resData.address2,
                bunkDistrict: resData.district,
                bunkState: resData.state,
                bunkPinCode: resData.pincode,
                }
            setBunkSavedFormData(userDetails);
            setBunkSavedData(resData);
            } else {
            setCustomerror(error || 'Failed to fetch bunk data');
            }
        };
    
        if(mode === 'edit' && recordId != '') {
            fetchBunkData();
            let userUrlTxt = `${apiUrl}users?filter=roleKey|bunk_incharge%26entityIds|${recordId}`;
            setFetchUser(userUrlTxt);
        }
}, []);

useEffect(() => {
    if(userResData?.data) {
        let userResDataObj = userResData?.data[0];
        if(userResDataObj) {
            const userDataObj = {
                firstName: userResDataObj.firstName,
                lastName: userResDataObj.lastName,
                staffId: userResDataObj.staffId,
                gender: userResDataObj.gender,
                email: userResDataObj.email,
                phone: userResDataObj.phone,
                profileImage: userResDataObj.profileImage
        };
        setUserSavedData(userResDataObj);
        setUserSavedFormData(userDataObj);
        }
    }
}, [userResData]);


useEffect(() => {
    if(initialBunkData) {
        setBunkSavedFormData(initialBunkData);
    }
}, [initialBunkData]);


  const handleBunkSubmit = async (formData) => {
       setCustomerror('');
      if(formData !== '' && Object.keys(formData).length>0) {
          let bunkPinCode = (formData.bunkPinCode) ? parseInt(formData.bunkPinCode) : '';
          let bunkLatitude = (formData.bunkLatitude) ? formData.bunkLatitude.toString() : '';
          let bunkLongitude = (formData.bunkLongitude) ? formData.bunkLongitude.toString() : '';
          const payloadObj = {
                name: formData.bunkName,
                address1: formData.bunkAddress1,
                address2: formData.bunkAddress2,
                city: formData.bunkDistrict,
                district: formData.bunkDistrict,
                state: formData.bunkState,
                pincode: bunkPinCode,
                latitude: bunkLatitude,
                longitude: bunkLongitude,
            };

        if(bunkSavedData) {
            payloadObj.id = bunkSavedData.id;
            let payload = JSON.stringify(payloadObj);
            const { result, error: apiError } = await patchBunkData(payload);
            if(result && result?.data) {
                let apiRespObj = {...payloadObj};
                setBunkSavedData(apiRespObj);
                setActiveForm('incharge');
                setBunkSavedFormData(formData);
                updateFromApiResp('bunk', apiRespObj);
            } else {
                setCustomerror(apiError);
            }
        } else {
            let payload = JSON.stringify(payloadObj);
            const { result, error: apiError } = await postBunkData(payload);
            if(result && result?.data && result?.data?.id) {
                let apiRespObj = {id:result?.data?.id, ...payloadObj};
                setBunkSavedData(apiRespObj);
                setActiveForm('incharge');
                setBunkSavedFormData(formData);
                updateFromApiResp('bunk', apiRespObj);
            } else {
                setCustomerror(apiError);
            }
        }

      }
      
  };


  const handleInchargeSubmit = async (formData) => {
      setCustomerror('');
      if(formData !== '' && Object.keys(formData).length>0) {
          const entityIdsArr = [];
                entityIdsArr.push(bunkSavedData?.id);

          const payloadObj = {
                roleKey: 'bunk_incharge',
                dob: '1999-01-01',
                entityIds: entityIdsArr,
                ...formData
            };

        if(userSavedData) {
            payloadObj.id = userSavedData.id;
            let payload = JSON.stringify(payloadObj);
            const { result, error: apiError } = await patchUserData(payload);
            if(result && result?.data) {
                setUserSavedFormData(payloadObj);
                setActiveForm('camera');
                const mapDiv = document.querySelector('.map-page-wrapper');
                    mapDiv.classList.add('map-form-card-fullwd');
            } else {
                setCustomerror(apiError);
            }
        } else {
            let payload = JSON.stringify(payloadObj);
            const { result, error: apiError } = await postUserData(payload);
            if(result && result?.data) {
                setUserSavedData(result?.data);
                setUserSavedFormData(payloadObj);
                setActiveForm('camera');
                const mapDiv = document.querySelector('.map-page-wrapper');
                    mapDiv.classList.add('map-form-card-fullwd');
            } else {
                setCustomerror(apiError);
            }
        }

      }
      
  };

  const handleAction = (actText) => {
        if(actText === 'go-to-bunk') {
            setActiveForm('bunk');
        }
        if(actText === 'go-to-incharge') {
            setActiveForm('incharge');
            const mapDiv = document.querySelector('.map-page-wrapper');
                  mapDiv.classList.remove('map-form-card-fullwd');
        }
        if(actText === 'close-form') {
            /*navigate(-1);*/
            /*window.location.href = '/bunk';*/
            navigate(basePage);
        }
  }

  return (<div className='petrolbunk-overall-forms'>

                {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}

                {(activeForm === 'bunk') && <div className='bunk-form-section'>
                    <BunkForm mode={mode} onSubmit={handleBunkSubmit} handleAction={handleAction} initialData={initialBunkData} bunkSavedFormData={bunkSavedFormData} loading={(mode==='add')?bunkloading:updatebunkLoading} />
                </div>}
                {(activeForm === 'incharge' && bunkSavedData?.id) && <div className='incharge-form-section'>
                    <InchargeForm mode={mode} onSubmit={handleInchargeSubmit} handleAction={handleAction} initialData={userSavedFormData} loading={(mode==='add')?userloading:updateuserLoading} />
                </div>}
                {(activeForm === 'camera' && bunkSavedData?.id) && <div className='camera-form-section'>
                    <CameraForm mode={mode} onSubmit={handleInchargeSubmit} handleAction={handleAction} bunkSavedData={bunkSavedData} loading={userloading} />
                </div>}
         </div>);
};

export default PetrolBunkForm;
